import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  { id: "dbc9f3cc-4fdd-4c53-b0a6-90d3302bb321", content: "p(R, kR = 0.1)", options: {} },
  { id: "0cb230af-337c-418e-b493-34d886af5fb2", content: "p(10R, kR = 0.1)", options: {} },
  { id: "69f80878-2d28-4830-9a4f-3ef857fa4be5", content: "p(R, kR = 1)", options: {} },
  { id: "5033ffe9-375f-4ec0-805c-f6815fb07c0b", content: "p(10R, kR = 1)", options: {} },
  { id: "006dd06a-c7b7-453c-a4fd-f2222424946e", content: "p(R, kR = 10)", options: {} },
  { id: "433d85fc-2961-40f8-84c8-ecf336ec3d16", content: "p(10R, kR = 10)", options: {} },
];

const groups = [
  {
    id: "ecdf8805-5a62-40bd-b9ee-74ea36dd0928",
    options: { imageUrl: `${config.ASSETS_URL}/01/13/task/task-1-group-1.svg` },
  },
  {
    id: "2d23cc25-2e13-4d99-90c0-1ed1edeceb31",
    options: { imageUrl: `${config.ASSETS_URL}/01/13/task/task-1-group-2.svg` },
  },
  {
    id: "03d902a9-eeba-4be2-82af-29f6156a7f87",
    options: { imageUrl: `${config.ASSETS_URL}/01/13/task/task-1-group-3.svg` },
  },
  {
    id: "9d3480d4-b818-4c13-878d-38ecd74b3aae",
    options: { imageUrl: `${config.ASSETS_URL}/01/13/task/task-1-group-4.svg` },
  },
  {
    id: "222f3166-4a12-4b49-a5ed-738f135cdaf9",
    options: { imageUrl: `${config.ASSETS_URL}/01/13/task/task-1-group-5.svg` },
  },
];

export const task: Task = {
  id: "06bb625e-99c4-4edd-97f5-0d3a3d1f23c3",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
    multipleConnection: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "ecdf8805-5a62-40bd-b9ee-74ea36dd0928", itemsId: ["5033ffe9-375f-4ec0-805c-f6815fb07c0b"] },
    { groupId: "2d23cc25-2e13-4d99-90c0-1ed1edeceb31", itemsId: ["433d85fc-2961-40f8-84c8-ecf336ec3d16"] },
    {
      groupId: "03d902a9-eeba-4be2-82af-29f6156a7f87",
      itemsId: ["0cb230af-337c-418e-b493-34d886af5fb2", "006dd06a-c7b7-453c-a4fd-f2222424946e"],
    },
    { groupId: "9d3480d4-b818-4c13-878d-38ecd74b3aae", itemsId: ["69f80878-2d28-4830-9a4f-3ef857fa4be5"] },
    { groupId: "222f3166-4a12-4b49-a5ed-738f135cdaf9", itemsId: ["dbc9f3cc-4fdd-4c53-b0a6-90d3302bb321"] },
  ],
};
